import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import Image from "src/Common/Image";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_GEN_AI_DEMO_IEAM_1 = {
  title:
    "Meet Tony, a warehouse manager\nseeking the ideal tech solution. He knows\nhe needs a drone solution but is \noverwhelmed by technical jargon.\n\n This is where Infosys Edge Application\nManagement comes to the rescue.",
  subtitle: "ai ASSISTED demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_117"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_GEN_AI_Demo_01.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{ position: "absolute", bottom: "121px", right: "607px" }}
          imagePath="ENG/IEAM/IEAM_GEN_AI_Demo_01_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "800px",
            height: "auto",
            bottom: "0px",
            right: "-79px",
          }}
          imagePath="ENG/characters/character_3.gif"
        />
      </div>
    </div>
  ),
};
